let activeVideo = null;

const playVideo = async (videoElement, playBtn) => {
  // Ставимо на паузу попереднє відео, якщо воно є
  if (activeVideo && activeVideo !== videoElement) {
    activeVideo.pause();
    activeVideo.controls = false;

    const prevPlayBtn = activeVideo
      .closest('.media-box')
      ?.querySelector('.media-placeholder');
    if (prevPlayBtn) prevPlayBtn.style.display = '';
  }

  try {
    await videoElement.play();
    videoElement.controls = true;
    playBtn.style.display = 'none';
    activeVideo = videoElement;
  } catch (err) {
    console.log('Playback error:', err);
  }
};

document.querySelectorAll('.media-box').forEach(elem => {
  const video = elem.querySelector('video');
  const videoPlay = elem.querySelector('.media-placeholder');

  if (!video || !videoPlay) return;

  const onPlayClick = () => {
    playVideo(video, videoPlay);
  };

  video.addEventListener('click', onPlayClick);
  videoPlay.addEventListener('click', onPlayClick);

  video.addEventListener('ended', () => {
    video.controls = false;
    videoPlay.style.display = '';
    if (activeVideo === video) activeVideo = null;
  });
});

// Функція ручної зупинки всіх відео
export function pauseVideo() {
  const videos = document.querySelectorAll('.media-box video');
  videos.forEach(video => {
    video.pause();
    video.controls = false;
    const playBtn = video
      .closest('.media-box')
      ?.querySelector('.media-placeholder');
    if (playBtn) playBtn.style.display = '';
  });
  activeVideo = null;
}

const isFullscreen = () =>
  document.fullscreenElement || document.webkitFullscreenElement;

let lastScrollY = window.scrollY;
let scrollBeforeFull = null;
let elemBeforeFull = null;

window.addEventListener(
  'scroll',
  () => {
    if (!isFullscreen()) {
      lastScrollY = window.scrollY;
    }
  },
  { passive: true }
);

const onFullscreenChange = () => {
  const elem = isFullscreen();

  if (elem) {
    scrollBeforeFull = window.scrollY || lastScrollY;
    elemBeforeFull = elem;
    return;
  }

  const top = scrollBeforeFull;
  const target = elemBeforeFull;

  scrollBeforeFull = null;
  elemBeforeFull = null;

  const restore = () => {
    if (top) {
      window.scrollTo({ top, behavior: 'auto' });
      lastScrollY = top;
      return;
    }

    target?.scrollIntoView({ block: 'center' });
  };

  restore();
  requestAnimationFrame(restore);
};

document.addEventListener('fullscreenchange', onFullscreenChange);
document.addEventListener('webkitfullscreenchange', onFullscreenChange);

// <div class="__media media-box">
//   <video poster="/assets/img/content/review_img_1.jpg" preload="metadata">
//     <source src="/assets/img/media/video.mp4" type="video/mp4" />
//     <source src="/assets/img/media/video.webm" type="video/webm" />
//   </video>

//   <div class="media-placeholder">
//     <button type="button" class="video-play" aria-label="Video play"></button>
//   </div>
// </div>

// <div class="__media">
//   <iframe
//     src="https://www.youtube.com/embed/s3a4OQR-10M?si=w_yydD2D1M8jmiWw"
//     title="Description"
//     loading="lazy"
//     allow="
//               accelerometer;
//               autoplay;
//               clipboard-write;
//               encrypted-media;
//               gyroscope;
//               picture-in-picture;
//               web-share;
//             "
//     referrerpolicy="strict-origin-when-cross-origin"
//     allowfullscreen
//   ></iframe>
// </div>
